module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Warrior.c3970c3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Warrior.jpg
// module id = dpZR
// module chunks = 0